import { ListItemIcon, ListItemText, styled } from '@mui/material';

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(2),
  color: theme.palette.grey[900],
  marginRight: theme.spacing(1),
  marginTop: theme.spacing(0.8),
  alignSelf: 'flex-start',
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  display: 'flex',
  '& .MuiTypography-root': {
    fontSize: 16,
  },
  '& .MuiTypography-secondary': {
    fontSize: 16,
    marginLeft: theme.spacing(0.5),
  },
}));

export const ComingSoonText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontWeight: 900,
}));
